export const DISCOVER_ART_DEMO_SLIDER_IMAGE =
  'https://drupal.sakipsabancimuzesi.org/sites/default/files/2026-06/SO19PB8_451_G3_12_web.jpg'

export const DISCOVER_ART_DEMO_SLIDER_MOBILE_IMAGE =
  'https://drupal.sakipsabancimuzesi.org/sites/default/files/2026-06/Yu%CC%88kselis%CC%A7_Arising-mobile.jpg'

export const DISCOVER_ART_DEMO_SLIDER_ID = 'web-performance-arising-a-call'
